"use client";

import { useEffect } from "react";
import { installDomNodeRemovalGuard } from "@/lib/dom-node-removal-guard";

/**
 * Mounted once at the root layout. Installs the global DOM-node-removal
 * guard before any client component renders so portal-heavy components
 * (Radix Dialog, Select, Popover) survive browser extensions that mutate
 * the DOM out from under React.
 */
export function DomNodeRemovalGuardMount() {
  useEffect(() => {
    installDomNodeRemovalGuard();
  }, []);
  return null;
}
